import { Typography, useTheme } from "@mui/material";
import { type FC, useMemo } from "react";
import { useIsDarkMode } from "web_myplann/Shared/Renderer/useIsDarkMode";
import {
	DANGER_MYPLANN_DARK,
	DANGER_MYPLANN_LIGHT,
	SUCCESS_MYPLANN_DARK,
	SUCCESS_MYPLANN_LIGHT,
} from "web_myplann/Utils/constants";

type Props = {
	textBefore?: string;
	change?: number | null;
	textAfter?: string;
	fontSize?: number;
	fontWeight?: number;
	lineHeight?: number | string;
	color?: string;
};

export const PercentageDelta: FC<Props> = ({
	textBefore,
	change,
	textAfter,
	fontSize,
	fontWeight,
	lineHeight,
	color,
}) => {
	const theme = useTheme();
	const isDark = useIsDarkMode();

	const computedColor = useMemo(() => {
		if (change == null || change === 0) {
			return theme.palette.deprecated.grey[500];
		}

		const isPositive = change > 0;

		if (isPositive) {
			return isDark ? SUCCESS_MYPLANN_DARK : SUCCESS_MYPLANN_LIGHT;
		}

		return isDark ? DANGER_MYPLANN_DARK : DANGER_MYPLANN_LIGHT;
	}, [change, isDark, theme.palette.deprecated.grey]);

	if (change == null || Number.isNaN(change)) {
		return null;
	}

	const sign = change <= 0 ? "" : "+";

	return (
		<Typography
			fontSize={fontSize ?? 14}
			fontWeight={fontWeight ?? 600}
			lineHeight={lineHeight}
			color={color ?? computedColor}
		>
			{textBefore}
			{sign}
			{change.toLocaleString("cs-CZ", {
				minimumFractionDigits: change === 0 ? 0 : 2,
				maximumFractionDigits: 2,
			})}
			{"\u00A0%"}
			{textAfter}
		</Typography>
	);
};
